<template>
  <div class="Home">
    <div class="content">
      <div class="content-width">
        <div class="banner">
          <div class="Popupbox" @mouseleave="setPopup(false)">
            <div class="banner-left">
              <div class="classify-title">
                <img src="@/assets/Home/分类.png" alt="" />
                <span>{{ $t('home.Categories') }}</span>
              </div>
              <div
                class="classifyItem"
                v-for="(item, index) in classifyList"
                :key="index"
                @mouseenter="setPopup(true, item)"
              >
                <span>{{ item.text }}</span>
                <img
                  class="classifyItem-arrow"
                  src="@/assets/Home/右箭头.png"
                  alt=""
                />
              </div>
            </div>
            <div class="banner-center">
              <banner :isDesktop="isDesktop"></banner>
            </div>
            <!--  -->
            <div class="Popup" v-if="PopupShow">
              <!-- 弹出框{{ NowPopup. }} -->

              <div
                class="ul"
                v-for="(item, index) in NowPopup.detailsList"
                :key="index"
              >
                <div class="ulTitle popupOptions">{{ item.name }}</div>
                <div
                  class="li popupOptions"
                  v-for="(item2, index2) in item.list"
                  :key="index2"
                >
                  {{ item2 }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="categorizedProductDisplay">
          <div class="categorizedProductDisplayItem">
            <categorizedProductDisplayTwo></categorizedProductDisplayTwo>
          </div>
          <div class="categorizedProductDisplayItem">
            <categorizedProductDisplay></categorizedProductDisplay>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import Banner from '@/components/banner/index.vue';
import CategorizedProductDisplay from '@/components/categorizedProductDisplay/categorizedProductDisplay.vue';
import CategorizedProductDisplayTwo from '@/components/categorizedProductDisplay/categorizedProductDisplayTwo.vue';
const { t } = useI18n();
// 响应式数据
const PopupShow = ref(false);
const NowPopup = ref({});

// 静态数据
const navItem = [
  { text: '首页' },
  { text: '百货市场' },
  { text: '产业带' },
  { text: '限时秒杀' },
  { text: '尾货清仓' },
];

const navItems = [
  { text: '热卖' },
  { text: '转租转让' },
  { text: '论坛' },
  { text: '市场地图' },
  { text: '求购与库存' },
  { text: '订货通' },
  { text: '进口馆' },
  { text: '专供出口' },
  { text: '经侦' },
  { text: '品牌协会' },
];

const dynamicList = [
  { text: '爱妃百货举行最美老板娘时尚party' },
  { text: '爱妃百货销售量突破100亿' },
  { text: '爱妃百货日收入三千万' },
  { text: '加入爱妃百货日收入7000不是梦' },
];

const classifyList = [
  {
    text: 'Toys, Babies & Kids',
    detailsList: [
      {
        name: 'Plush Toys',
        list: [
          'Plush Dolls',
          'Plush Pendant',
          'Barbie Dolls',
          'Plush Backpack',
          'Plush Pillows',
          'Plush Sofa',
          'Plush Purses',
        ],
      },
      {
        name: 'Electric/RC Toys',
        list: [
          'Remote Control Cars',
          'Plush Pendant',
          'Remote Control Tanks',
          'Remote Control Planes',
          'Remote Control Drones',
          'Robots',
        ],
      },
      {
        name: 'Educational/Early education toy',
        list: [
          'Puzzle & Jigsaw',
          'Magic Cube',
          'Board Games',
          'Card Games',
          'Toy Blocks',
          'Story Machine',
        ],
      },
      {
        name: 'Novelty Toys',
        list: [
          'Stress Relief Toys',
          'Fidget Spinner',
          'Fidget Cube',
          'Inflatable Toys',
          'Inflatable Castle',
          'Inflatable Swimming Pool',
          'Inflatable Horse',
          'Swim Ring',
        ],
      },
      {
        name: 'Baby Care',
        list: [
          'Baby Shower Gel',
          'Baby Lotion',
          'Baby Nail Clipper',
          'Baby Wipes',
          'Baby Diapers',
        ],
      },
      {
        name: 'Baby Feeding',
        list: ['Pacifiers', 'Feeding-bottle', 'Baby Tableware'],
      },
      {
        name: 'Baby Clothing',
        list: [
          'Burp Cloths & Bibs',
          'Baby Hats',
          'Baby Clothes',
          'Baby Clothes',
          'Baby Socks',
          'Baby Shoes',
        ],
      },
      {
        name: 'Baby Carriage',
        list: ['Baby walker', 'Baby Stroller', 'Waist Stool'],
      },
    ],
  },
  {
    text: 'Fashion Jewelry & Accessories',
    detailsList: [
      {
        name: 'Fashion Jewelry',
        list: [
          'Necklace',
          'Bracelet & Bangle',
          'Barbie Dolls',
          'Ring',
          'Anklet',
          'Earrings',
          'Brooch',
          'Waist Chain',
        ],
      },
      {
        name: 'Electric/RC Toys',
        list: [
          'Hair Accessories',
          'Hair Rope',
          'Hairpin',
          'Hair Band',
          'Hair Claw',
        ],
      },
      {
        name: 'Jewelry Accessories',
        list: [
          'Jewelry Boxes',
          'Jewelry Display',
          'Jewelry Tools',
          'Lobster Clasps',
        ],
      },
      {
        name: 'Eyewear',
        list: [
          'Sunglasses',
          'Optical Glasses',
          'Reading Glasses',
          'Riding Glasses',
          'Watches',
          'Quartz Watch',
          'Mechanical Watch',
          'Smart Watch',
          'Electronic Watch',
          'Child Watch',
          'Sports Watch',
        ],
      },
      {
        name: 'Eyewear',
        list: [
          'Baby Shower Gel',
          'Baby Lotion',
          'Baby Nail Clipper',
          'Baby Wipes',
          'Baby Diapers',
        ],
      },
    ],
  },
  {
    text: 'Apparel & Accessories',
    detailsList: [
      {
        name: 'Plush Toys',
        list: [
          'Plush Dolls',
          'Plush Pendant',
          'Barbie Dolls',
          'Plush Backpack',
          'Plush Pillows',
          'Plush Sofa',
          'Plush Purses',
        ],
      },
      {
        name: 'Electric/RC Toys',
        list: [
          'Remote Control Cars',
          'Plush Pendant',
          'Remote Control Tanks',
          'Remote Control Planes',
          'Remote Control Drones',
          'Robots',
        ],
      },
      {
        name: 'Educational/Early education toy',
        list: [
          'Puzzle & Jigsaw',
          'Magic Cube',
          'Board Games',
          'Card Games',
          'Toy Blocks',
          'Story Machine',
        ],
      },
      {
        name: 'Novelty Toys',
        list: [
          'Stress Relief Toys',
          'Fidget Spinner',
          'Fidget Cube',
          'Inflatable Toys',
          'Inflatable Castle',
          'Inflatable Swimming Pool',
          'Inflatable Horse',
          'Swim Ring',
        ],
      },
      {
        name: 'Baby Care',
        list: [
          'Baby Shower Gel',
          'Baby Lotion',
          'Baby Nail Clipper',
          'Baby Wipes',
          'Baby Diapers',
        ],
      },
      {
        name: 'Baby Feeding',
        list: ['Pacifiers', 'Feeding-bottle', 'Baby Tableware'],
      },
      {
        name: 'Baby Clothing',
        list: [
          'Burp Cloths & Bibs',
          'Baby Hats',
          'Baby Clothes',
          'Baby Clothes',
          'Baby Socks',
          'Baby Shoes',
        ],
      },
      {
        name: 'Baby Carriage',
        list: ['Baby walker', 'Baby Stroller', 'Waist Stool'],
      },
    ],
  },
  {
    text: 'Shoes & Accessories',
    detailsList: [
      {
        name: 'Plush Toys',
        list: [
          'Plush Dolls',
          'Plush Pendant',
          'Barbie Dolls',
          'Plush Backpack',
          'Plush Pillows',
          'Plush Sofa',
          'Plush Purses',
        ],
      },
      {
        name: 'Electric/RC Toys',
        list: [
          'Remote Control Cars',
          'Plush Pendant',
          'Remote Control Tanks',
          'Remote Control Planes',
          'Remote Control Drones',
          'Robots',
        ],
      },
      {
        name: 'Educational/Early education toy',
        list: [
          'Puzzle & Jigsaw',
          'Magic Cube',
          'Board Games',
          'Card Games',
          'Toy Blocks',
          'Story Machine',
        ],
      },
      {
        name: 'Novelty Toys',
        list: [
          'Stress Relief Toys',
          'Fidget Spinner',
          'Fidget Cube',
          'Inflatable Toys',
          'Inflatable Castle',
          'Inflatable Swimming Pool',
          'Inflatable Horse',
          'Swim Ring',
        ],
      },
      {
        name: 'Baby Care',
        list: [
          'Baby Shower Gel',
          'Baby Lotion',
          'Baby Nail Clipper',
          'Baby Wipes',
          'Baby Diapers',
        ],
      },
      {
        name: 'Baby Feeding',
        list: ['Pacifiers', 'Feeding-bottle', 'Baby Tableware'],
      },
      {
        name: 'Baby Clothing',
        list: [
          'Burp Cloths & Bibs',
          'Baby Hats',
          'Baby Clothes',
          'Baby Clothes',
          'Baby Socks',
          'Baby Shoes',
        ],
      },
      {
        name: 'Baby Carriage',
        list: ['Baby walker', 'Baby Stroller', 'Waist Stool'],
      },
    ],
  },
  {
    text: 'Daily Necessities',
    detailsList: [
      {
        name: 'Plush Toys',
        list: [
          'Plush Dolls',
          'Plush Pendant',
          'Barbie Dolls',
          'Plush Backpack',
          'Plush Pillows',
          'Plush Sofa',
          'Plush Purses',
        ],
      },
      {
        name: 'Electric/RC Toys',
        list: [
          'Remote Control Cars',
          'Plush Pendant',
          'Remote Control Tanks',
          'Remote Control Planes',
          'Remote Control Drones',
          'Robots',
        ],
      },
      {
        name: 'Educational/Early education toy',
        list: [
          'Puzzle & Jigsaw',
          'Magic Cube',
          'Board Games',
          'Card Games',
          'Toy Blocks',
          'Story Machine',
        ],
      },
      {
        name: 'Novelty Toys',
        list: [
          'Stress Relief Toys',
          'Fidget Spinner',
          'Fidget Cube',
          'Inflatable Toys',
          'Inflatable Castle',
          'Inflatable Swimming Pool',
          'Inflatable Horse',
          'Swim Ring',
        ],
      },
      {
        name: 'Baby Care',
        list: [
          'Baby Shower Gel',
          'Baby Lotion',
          'Baby Nail Clipper',
          'Baby Wipes',
          'Baby Diapers',
        ],
      },
      {
        name: 'Baby Feeding',
        list: ['Pacifiers', 'Feeding-bottle', 'Baby Tableware'],
      },
      {
        name: 'Baby Clothing',
        list: [
          'Burp Cloths & Bibs',
          'Baby Hats',
          'Baby Clothes',
          'Baby Clothes',
          'Baby Socks',
          'Baby Shoes',
        ],
      },
      {
        name: 'Baby Carriage',
        list: ['Baby walker', 'Baby Stroller', 'Waist Stool'],
      },
    ],
  },
  {
    text: 'Home Appliances',
    detailsList: [
      {
        name: 'Plush Toys',
        list: [
          'Plush Dolls',
          'Plush Pendant',
          'Barbie Dolls',
          'Plush Backpack',
          'Plush Pillows',
          'Plush Sofa',
          'Plush Purses',
        ],
      },
      {
        name: 'Electric/RC Toys',
        list: [
          'Remote Control Cars',
          'Plush Pendant',
          'Remote Control Tanks',
          'Remote Control Planes',
          'Remote Control Drones',
          'Robots',
        ],
      },
      {
        name: 'Educational/Early education toy',
        list: [
          'Puzzle & Jigsaw',
          'Magic Cube',
          'Board Games',
          'Card Games',
          'Toy Blocks',
          'Story Machine',
        ],
      },
      {
        name: 'Novelty Toys',
        list: [
          'Stress Relief Toys',
          'Fidget Spinner',
          'Fidget Cube',
          'Inflatable Toys',
          'Inflatable Castle',
          'Inflatable Swimming Pool',
          'Inflatable Horse',
          'Swim Ring',
        ],
      },
      {
        name: 'Baby Care',
        list: [
          'Baby Shower Gel',
          'Baby Lotion',
          'Baby Nail Clipper',
          'Baby Wipes',
          'Baby Diapers',
        ],
      },
      {
        name: 'Baby Feeding',
        list: ['Pacifiers', 'Feeding-bottle', 'Baby Tableware'],
      },
      {
        name: 'Baby Clothing',
        list: [
          'Burp Cloths & Bibs',
          'Baby Hats',
          'Baby Clothes',
          'Baby Clothes',
          'Baby Socks',
          'Baby Shoes',
        ],
      },
      {
        name: 'Baby Carriage',
        list: ['Baby walker', 'Baby Stroller', 'Waist Stool'],
      },
    ],
  },
  {
    text: 'Beauty & Personal Care',
    detailsList: [
      {
        name: 'Plush Toys',
        list: [
          'Plush Dolls',
          'Plush Pendant',
          'Barbie Dolls',
          'Plush Backpack',
          'Plush Pillows',
          'Plush Sofa',
          'Plush Purses',
        ],
      },
      {
        name: 'Electric/RC Toys',
        list: [
          'Remote Control Cars',
          'Plush Pendant',
          'Remote Control Tanks',
          'Remote Control Planes',
          'Remote Control Drones',
          'Robots',
        ],
      },
      {
        name: 'Educational/Early education toy',
        list: [
          'Puzzle & Jigsaw',
          'Magic Cube',
          'Board Games',
          'Card Games',
          'Toy Blocks',
          'Story Machine',
        ],
      },
      {
        name: 'Novelty Toys',
        list: [
          'Stress Relief Toys',
          'Fidget Spinner',
          'Fidget Cube',
          'Inflatable Toys',
          'Inflatable Castle',
          'Inflatable Swimming Pool',
          'Inflatable Horse',
          'Swim Ring',
        ],
      },
      {
        name: 'Baby Care',
        list: [
          'Baby Shower Gel',
          'Baby Lotion',
          'Baby Nail Clipper',
          'Baby Wipes',
          'Baby Diapers',
        ],
      },
      {
        name: 'Baby Feeding',
        list: ['Pacifiers', 'Feeding-bottle', 'Baby Tableware'],
      },
      {
        name: 'Baby Clothing',
        list: [
          'Burp Cloths & Bibs',
          'Baby Hats',
          'Baby Clothes',
          'Baby Clothes',
          'Baby Socks',
          'Baby Shoes',
        ],
      },
      {
        name: 'Baby Carriage',
        list: ['Baby walker', 'Baby Stroller', 'Waist Stool'],
      },
    ],
  },
  {
    text: 'Luggage, Bags & Cases',
    detailsList: [
      {
        name: 'Plush Toys',
        list: [
          'Plush Dolls',
          'Plush Pendant',
          'Barbie Dolls',
          'Plush Backpack',
          'Plush Pillows',
          'Plush Sofa',
          'Plush Purses',
        ],
      },
      {
        name: 'Electric/RC Toys',
        list: [
          'Remote Control Cars',
          'Plush Pendant',
          'Remote Control Tanks',
          'Remote Control Planes',
          'Remote Control Drones',
          'Robots',
        ],
      },
      {
        name: 'Educational/Early education toy',
        list: [
          'Puzzle & Jigsaw',
          'Magic Cube',
          'Board Games',
          'Card Games',
          'Toy Blocks',
          'Story Machine',
        ],
      },
      {
        name: 'Novelty Toys',
        list: [
          'Stress Relief Toys',
          'Fidget Spinner',
          'Fidget Cube',
          'Inflatable Toys',
          'Inflatable Castle',
          'Inflatable Swimming Pool',
          'Inflatable Horse',
          'Swim Ring',
        ],
      },
      {
        name: 'Baby Care',
        list: [
          'Baby Shower Gel',
          'Baby Lotion',
          'Baby Nail Clipper',
          'Baby Wipes',
          'Baby Diapers',
        ],
      },
      {
        name: 'Baby Feeding',
        list: ['Pacifiers', 'Feeding-bottle', 'Baby Tableware'],
      },
      {
        name: 'Baby Clothing',
        list: [
          'Burp Cloths & Bibs',
          'Baby Hats',
          'Baby Clothes',
          'Baby Clothes',
          'Baby Socks',
          'Baby Shoes',
        ],
      },
      {
        name: 'Baby Carriage',
        list: ['Baby walker', 'Baby Stroller', 'Waist Stool'],
      },
    ],
  },
  {
    text: 'Consumer Electronics',
    detailsList: [
      {
        name: 'Plush Toys',
        list: [
          'Plush Dolls',
          'Plush Pendant',
          'Barbie Dolls',
          'Plush Backpack',
          'Plush Pillows',
          'Plush Sofa',
          'Plush Purses',
        ],
      },
      {
        name: 'Electric/RC Toys',
        list: [
          'Remote Control Cars',
          'Plush Pendant',
          'Remote Control Tanks',
          'Remote Control Planes',
          'Remote Control Drones',
          'Robots',
        ],
      },
      {
        name: 'Educational/Early education toy',
        list: [
          'Puzzle & Jigsaw',
          'Magic Cube',
          'Board Games',
          'Card Games',
          'Toy Blocks',
          'Story Machine',
        ],
      },
      {
        name: 'Novelty Toys',
        list: [
          'Stress Relief Toys',
          'Fidget Spinner',
          'Fidget Cube',
          'Inflatable Toys',
          'Inflatable Castle',
          'Inflatable Swimming Pool',
          'Inflatable Horse',
          'Swim Ring',
        ],
      },
      {
        name: 'Baby Care',
        list: [
          'Baby Shower Gel',
          'Baby Lotion',
          'Baby Nail Clipper',
          'Baby Wipes',
          'Baby Diapers',
        ],
      },
      {
        name: 'Baby Feeding',
        list: ['Pacifiers', 'Feeding-bottle', 'Baby Tableware'],
      },
      {
        name: 'Baby Clothing',
        list: [
          'Burp Cloths & Bibs',
          'Baby Hats',
          'Baby Clothes',
          'Baby Clothes',
          'Baby Socks',
          'Baby Shoes',
        ],
      },
      {
        name: 'Baby Carriage',
        list: ['Baby walker', 'Baby Stroller', 'Waist Stool'],
      },
    ],
  },
  {
    text: 'Sports & Entertainment',
    detailsList: [
      {
        name: 'Plush Toys',
        list: [
          'Plush Dolls',
          'Plush Pendant',
          'Barbie Dolls',
          'Plush Backpack',
          'Plush Pillows',
          'Plush Sofa',
          'Plush Purses',
        ],
      },
      {
        name: 'Electric/RC Toys',
        list: [
          'Remote Control Cars',
          'Plush Pendant',
          'Remote Control Tanks',
          'Remote Control Planes',
          'Remote Control Drones',
          'Robots',
        ],
      },
      {
        name: 'Educational/Early education toy',
        list: [
          'Puzzle & Jigsaw',
          'Magic Cube',
          'Board Games',
          'Card Games',
          'Toy Blocks',
          'Story Machine',
        ],
      },
      {
        name: 'Novelty Toys',
        list: [
          'Stress Relief Toys',
          'Fidget Spinner',
          'Fidget Cube',
          'Inflatable Toys',
          'Inflatable Castle',
          'Inflatable Swimming Pool',
          'Inflatable Horse',
          'Swim Ring',
        ],
      },
      {
        name: 'Baby Care',
        list: [
          'Baby Shower Gel',
          'Baby Lotion',
          'Baby Nail Clipper',
          'Baby Wipes',
          'Baby Diapers',
        ],
      },
      {
        name: 'Baby Feeding',
        list: ['Pacifiers', 'Feeding-bottle', 'Baby Tableware'],
      },
      {
        name: 'Baby Clothing',
        list: [
          'Burp Cloths & Bibs',
          'Baby Hats',
          'Baby Clothes',
          'Baby Clothes',
          'Baby Socks',
          'Baby Shoes',
        ],
      },
      {
        name: 'Baby Carriage',
        list: ['Baby walker', 'Baby Stroller', 'Waist Stool'],
      },
    ],
  },
];

// 方法
const setPopup = (show, item = {}) => {
  PopupShow.value = show;
  NowPopup.value = item;
};
</script>

<style lang="less" scoped>
.Home {
  .content {
    padding-top: 10px;
    background: rgb(249, 249, 249);
    min-width: 1200px;
    padding-bottom: 40px;
    // height: 90vh;
    .content-width {
      width: 1200px;
      margin: 0 auto;
      .banner {
        display: flex;
        .Popupbox {
          display: flex;
          position: relative;
          .Popup {
            position: absolute;
            width: 900px;
            height: 450px;
            // border: 1px solid red;
            background-color: #fff;
            padding: 15px;
            left: 300px;
            z-index: 4;
            font-size: 20px;
            display: flex;
            flex-wrap: wrap;
            // flex-direction: column; /* 改为列布局 */

            // align-items: flex-start;
            .ulTitle {
              font-weight: 700;
              padding-bottom: 10px;
            }
            .ul {
              margin: 0px 15px 15px 0px;
              display: block; /* 或者 inline-block */
              height: auto !important;
              color: #333;
              font-size: 16px;
              min-height: 0; /* 添加这个确保最小高度不限制 */
            }
            .li {
              display: block;
              font-size: 14px;
              line-height: 24px;
            }
            .popupOptions:hover {
              color: #025ce3;
              cursor: pointer;
            }
            // 0065ff
          }
        }
        .banner-left {
          width: 300px;
          height: 450px;
          padding: 10px;
          display: flex;
          flex-direction: column;
          background-color: #fff;
          border-radius: 8px 0px 0px 8px;
          .classifyItem {
            line-height: 39px;
            color: #333;
            cursor: pointer;
            padding-left: 20px;
            // line-height: 39px;
            justify-content: space-between;
            padding-right: 18px;
            font-size: 14px;
            display: flex;
            align-items: center;
            // font-weight: 500;
            .classifyItem-arrow {
              width: 20px;
              height: 20px;
              vertical-align: middle;
            }
            // text-indent: 1em;
          }
          .classifyItem:hover {
            font-weight: 700;
            color: #f60;
            box-shadow: 0px 2px 5px #ddd;
          }
          .classify-title {
            display: flex;
            padding-left: 10px;
            font-size: 18px;
            height: 80px;
            line-height: 40px;
            font-weight: 700;
            align-items: center;
            img {
              width: 22px;
              height: 22px;
              margin-right: 10px;
            }
          }
        }
        .banner-center {
          width: 900px;
          height: 450px;
          background-color: #fff;
          // margin-left: 15px;
          padding: 20px 10px;
        }
      }
      .categorizedProductDisplay {
        margin-top: 20px;
      }
    }
  }
}
</style>
